import { render, staticRenderFns } from "./tiqianReport.vue?vue&type=template&id=28793b9e&scoped=true&"
import script from "./tiqianReport.vue?vue&type=script&lang=js&"
export * from "./tiqianReport.vue?vue&type=script&lang=js&"
import style0 from "./tiqianReport.vue?vue&type=style&index=0&id=28793b9e&scoped=true&lang=less&"
import style1 from "./tiqianReport.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28793b9e",
  null
  
)

export default component.exports